import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Absturznetz } from './bausteine/Absturznetz'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import './stil.css'
import { App } from './App'
import { KontoAnbieter } from './konto/KontoKontext'
import { anVerbindungKoppeln } from './offline/warteschlange'
import { serviceWorkerAnmelden } from './pwa/aktualisierung'

const abfragen = new QueryClient({
  defaultOptions: {
    queries: {
      // Draußen zählt jedes Byte: eine Minute lang gilt Geladenes als frisch.
      staleTime: 60_000,
      // Fachliche Fehler (404, 403) nicht wiederholen – nur Netzfehler.
      retry: (versuche, fehler) => {
        const status = (fehler as { status?: number })?.status
        if (status && status < 500) return false
        return versuche < 2
      },
      refetchOnWindowFocus: false,
    },
  },
})

// Beide laufen vor dem ersten Aufbau der Oberfläche. Flöge hier eine
// Ausnahme, käme `render` nie dran: keine App, kein Absturznetz, weiße
// Seite. Weder die Offlinehülle noch die Warteschlange sind das wert – ohne
// sie arbeitet die App weiter, nur eben ohne Zwischenspeicher.
try {
  serviceWorkerAnmelden()
} catch (fehler) {
  console.warn('Service Worker übersprungen', fehler)
}

try {
  anVerbindungKoppeln()
} catch (fehler) {
  console.warn('Warteschlange nicht angekoppelt', fehler)
}

createRoot(document.getElementById('wurzel')!).render(
  <StrictMode>
    <QueryClientProvider client={abfragen}>
      <BrowserRouter>
        {/* Innerhalb des Routers, damit die Meldung mit Kopfzeile und
            Navigation erscheint und man von dort weiterkommt. Weiter außen
            wäre nach einem Fehler nur noch die Meldung übrig. */}
        <Absturznetz>
          <KontoAnbieter>
            <App />
          </KontoAnbieter>
        </Absturznetz>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
